import React from "react";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import nextjs from "../assets/nextjs.png";
import node from "../assets/node.png";
import mongodb from "../assets/mongodb.png";
import react from "../assets/react.png";
import tailwind from "../assets/tailwind.png";
import github from "../assets/github.png";
const Experience = () => {
  const langues = [
    {
      id: 1,
      src: html,
      title: 'HTML',
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: 'CSS',
      style: "shadow-blue-400",
    },
    {
      id: 3,
      src: javascript,
      title: 'JS',
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: react,
      title: 'REACT',
      style: "shadow-cyan-500",
    },
    {
      id: 5,
      src: nextjs,
      title: 'NEXT JS',
      style: "shadow-slate-300",
    },
    {
      id: 6,
      src: mongodb,
      title: 'MONGO',
      style: "shadow-green-500",
      
    },
    {
      id: 7,
      src: node,
      title: 'NODE JS',
      style: "shadow-lime-500",
    },
    {
      id: 8,
      src: tailwind,
      title: 'TAILWIND',
      style: "shadow-cyan-400",
    },
    {
      id: 9,
      src: github,
      title: 'GITHUB',
      style: "shadow-slate-400",
    },
  ];
  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-auto pt-28"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div data-aos="fade-right"  data-aos-duration="1800">
          <h2 className="text-5xl inline border-b-4 border-gray-500 p-2">
            Experience
          </h2>
          <p className="mt-20 text-xl text-gray-400">
            These are the technologies I've worked with
          </p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0" data-aos="fade-up"  data-aos-duration="2000">

            {
                langues.map(({id, src, title, style}) =>(
            

          <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-full ${style}`   }>
            <img src={src} alt="html" className="w-20 mx-auto mt-4" />
            <p className="my-4">{title}</p>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
